



import VIPSection from '../sections/vip/default';




import "./style.css";


const VipPage = ()=>{
  
return (
  <div id="vipPage" class="page ">
  
  

  
  <VIPSection desktopToggle={ true } mobileToggle={
    true } bgSection={ false } mobileTitleToggle={ true } mobileBannerToggle={ true } desktopBannerToggle={
    true } mode={`tab`} vipContentToggle={ false } aboutUsToggle={ true }
    faqToggle={ true } tncToggle={ true } benefitToggle={
    false } reviewToggle={ false } />
  
  
  

  
</div>
)
}

export default VipPage;